import { css } from "@emotion/react";
import {
  colors,
  breakpoints,
} from "@mytutor/shared-react-web-components/lib/theme";
import { staticSubjectsData } from "../../util/data/subjects";
import { staticLevelsData } from "../../util/data/levels";
import { Subjects } from "../../models/Subjects";
import { Levels } from "../../models/Levels";

type Props = {
  urlSubject: string;
  urlLevel: string;
  authenticated: boolean;
};

const breadcrumbsStyle = css`
  //hide with CSS so still in the HTML for SEO
  display: none;
  a, span {
    font-family: FoundersGrotesk,sans-serif;
    font-style: normal;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.03em;
    color: ${colors.neutral6};
  }
  * {
    margin-right: 6px;
  }
  @media (min-width: ${breakpoints.tablet}px) {
    display: block;
  }
`;

const authenticatedBreadcrumbsStyle = css`
  &&& {
    padding-left: 45px;
  }
`;

const getSubjectName = (data: Array<Subjects>, urlSubject: string) => {
  if (!urlSubject) {
    return;
  }
  return data.filter((subject) => subject.urlSubject === urlSubject)[0]
    ?.subject;
};

const getLevelName = (data: Array<Levels>, urlLevel: string) => {
  if (!urlLevel) {
    return;
  }
  return data.filter((level) => level.urlLevel === urlLevel)[0]?.level;
};

const Breadcrumbs = ({ urlSubject, urlLevel, authenticated }: Props) => {
  //subjectAndLevel prop uses the URL value, this needs to be converted the name value.
  //returns undefined if the URL value is not valid
  const subjectName = getSubjectName(staticSubjectsData, urlSubject);
  const levelName = getLevelName(staticLevelsData, urlLevel);

  //using the above value prevents injection as will be undefined if not valid
  const formattedSubjectURL = subjectName ? urlSubject + "/" : "";
  const formattedLevelURL = levelName ? urlLevel + "/" : "";

  const rootUrl = `${process.env.NEXT_PUBLIC_ZEUS_URL}/view-tutors/`;

  return (
    <div className="row" css={authenticated ? [breadcrumbsStyle, authenticatedBreadcrumbsStyle] : breadcrumbsStyle} data-test="breadcrumbs">
      <a href={process.env.NEXT_PUBLIC_ZEUS_URL + "/"}>Home</a>
      <span>{">"}</span>
      <a href={rootUrl}>View Tutors</a>
      {subjectName && (
        <>
          <span>{">"}</span>
          <a href={`${rootUrl}${formattedSubjectURL}`}>{subjectName} Tutors</a>
        </>
      )}
      {levelName && (
        <>
          <span>{">"}</span>
          <a href={`${rootUrl}${formattedSubjectURL}${formattedLevelURL}`}>
            {levelName} {subjectName} Tutors
          </a>
        </>
      )}
    </div>
  );
};

export default Breadcrumbs;
